import type { PatternAccessScope } from '~/common/logic/feature/settings/batch-type-library/pattern';

import type { BatchTypePatternTabKey, DocumentTypePatternTabKey } from './_common.type';

/**
 * Get scope from tab key.
 *
 * @param {BatchTypePatternTabKey | DocumentTypePatternTabKey} tabKey The tab key.
 *
 * @returns {PatternAccessScope} Scope.
 */
export function getScope(tabKey: BatchTypePatternTabKey | DocumentTypePatternTabKey): PatternAccessScope {
  return ['batchField', 'batchVariable', 'batchBusinessRule'].includes(tabKey) ? 'batch' : 'document';
}
